const theme = {
  colors: {
    main: "rgb(7, 182, 169)",
  },
};

export default theme;
